// Create component for the feature menu and include it in the below array in the required order

import { configurationMenus } from "./configuration"
import { cmsMenus } from "./content-management-system"
import { dbnCloudMenus } from "./dbn-cloud"
import { eAdvisorMenus } from "./eAdvisor"
import { eApplicationMenus } from "./eApplication"
import { edgeGatewayMenus } from "./edge-gateway"
import { organizationMenus } from "./organization"
import { policyMenus } from "./policy-manager"
import { routeManagerMenus } from "./route-manager"
import { salesMenus } from "./sales"
import { serviceMenus } from "./service"
import { settingMenus } from "./setting"
import { shippingManagerMenus } from "./shipping-manager"
import { shipxCloudMenus } from "./shipx-cloud"
import { smartBookingMenus } from "./smart-booking"
import { systemMenus } from "./system"
import { taxonomyMenus } from "./taxonomy"
import { transportManagerMenus } from "./transport-manager"

export const menusData = () => {
    return ([
        eAdvisorMenus(),
        taxonomyMenus(),
        routeManagerMenus(),
        shippingManagerMenus(),
        transportManagerMenus(),
        policyMenus(),
        salesMenus(),
        smartBookingMenus(),
        cmsMenus(),
        serviceMenus(),
        eApplicationMenus(),
        organizationMenus(),
        dbnCloudMenus(),
           shipxCloudMenus(),
        edgeGatewayMenus(),
        configurationMenus(),
        settingMenus(),
        systemMenus(),
    ])
}